import type { MarketName } from "@dransay/api/models";
import type { CountryCode } from "libphonenumber-js";
import type { supportedLngs } from "~/tooling/i18n/i18n.config";

export interface MarketConfig {
	code: MarketName;
	locale: (typeof supportedLngs)[number];
	phoneDefaultCountryCode: CountryCode;
	showDeliveryMethodBadgesThreshold: number;
	marketName: string;
	languageTag: "de-DE";
	allowUserPrescriptionUpload: boolean;
	allowCombinedPayment: boolean;
}

export const MarketConfigs: Record<MarketName, MarketConfig> = {
	de: {
		code: "de",
		locale: "de",
		phoneDefaultCountryCode: "DE",
		showDeliveryMethodBadgesThreshold: 1,
		marketName: "Germany",
		languageTag: "de-DE",
		allowUserPrescriptionUpload: true,
		allowCombinedPayment: true,
	},
};
